import {lonLatToTileNumbers, tileNumbersToLonLat, 
    gcj02_To_gps84, gps84_To_gcj02, 
    bd09_To_gps84, gps84_To_bd09} from './support/coordConver.js'
import TransformClassBaidu from './support/transform-class-baidu'
import {setOptions, template} from './support/Util.js'
import WebMercatorViewport from 'viewport-mercator-project';
import { getDistanceScales, zoomToScale } from './support/web-mercator.js';

import * as mat4 from 'gl-matrix/mat4';
import * as vec4 from 'gl-matrix/vec4';


export default class customTileLayer{
    constructor(layerId, url, options){
        options = options || {}
        this.id = layerId;
        this.type = "custom";
        this.renderingMode = '2d';
        this.url = url;

        this.options = {
          //服务器编号
          subdomains: null,
          visible:
            typeof options.visible !== "undefined" ? options.visible : true,
          opacity:
            typeof options.opacity !== "undefined" ? options.opacity : 1,
          minZoom: 3,
          maxZoom: 18,
          tileType: "xyz", //bd09,xyz
        };
        setOptions(this, options)   //合并属性

        //着色器程序 
        this.program;

        //存放当前显示的瓦片
        this.showTiles = []

        //存放所有加载过的瓦片
        this.tileCache = {}

        //存放瓦片号对应的经纬度
        this.gridCache = {}

        //记录渲染时的变换矩阵。
        //如果瓦片因为网速慢，在渲染完成后才加载过来，可以使用这个矩阵主动更新渲染
        this.matrix;

        this.map;

        //记录当前图层是否在显示
        this.isLayerShow;

        this.transformBaidu = new TransformClassBaidu()
    }


    onAdd(map, gl) {
      this.map = map;
      this.isEPSG4326 = map.crs.getEpsgCode() === "EPSG:4326";

      // 参考抖动问题的解决方案 https://github.com/mapbox/mapbox-gl-js/issues/7268
      var vertexSource =
        "" +
        "uniform mat4 u_custom_matrix;" +
        "uniform vec4 u_center_pos;" +
        "attribute vec4 a_Pos_Piexl;" +
        "attribute vec2 a_TextCoord_Piexl;" +
        "varying vec2 v_TextCoord;" +
        "vec2 translateRelativeToEye(vec2 high, vec2 low) {" +
        "   vec2 highDiff = high - vec2(u_center_pos.x, u_center_pos.z);" +
        "   vec2 lowDiff = low - vec2(u_center_pos.y, u_center_pos.w);" +
        "   return highDiff + lowDiff;" +
        "}" +
        "void main() {" +
        "   vec2 eye_offset = translateRelativeToEye(vec2(a_Pos_Piexl.x, a_Pos_Piexl.z), vec2(a_Pos_Piexl.y, a_Pos_Piexl.w));" +
        "   gl_Position = u_custom_matrix * vec4(eye_offset, 0.0, 1.0);" +
        "   v_TextCoord = a_TextCoord_Piexl;" +
        "}";

      var fragmentSource =
        "" +
        "precision mediump float;" +
        "uniform sampler2D u_Sampler; " +
        "varying vec2 v_TextCoord; " +
        "uniform vec2 u_viewport_size;" +
        "uniform float u_opacity;" +
        "void main() {" +
        "   vec4 color = texture2D(u_Sampler, v_TextCoord);" +
        "   color *= u_opacity;" +
        "   gl_FragColor = color;" +
        "}";

      //初始化顶点着色器
      var vertexShader = gl.createShader(gl.VERTEX_SHADER);
      gl.shaderSource(vertexShader, vertexSource);
      gl.compileShader(vertexShader);
      //初始化片元着色器
      var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      gl.shaderSource(fragmentShader, fragmentSource);
      gl.compileShader(fragmentShader);
      //初始化着色器程序
      this.program = gl.createProgram();
      gl.attachShader(this.program, vertexShader);
      gl.attachShader(this.program, fragmentShader);
      gl.linkProgram(this.program);

      this.a_Pos_Piexl = gl.getAttribLocation(this.program, "a_Pos_Piexl");
      this.a_TileZoomScale = gl.getAttribLocation(
            this.program,
            "a_TileZoomScale"
        );
      this.a_TextCoord_Piexl = gl.getAttribLocation(
            this.program,
            "a_TextCoord_Piexl"
        );

      this.isLayerShow = true;
      map.on("move", () => {
        if (this.isLayerShow) {
          this.update(gl, map);
        }
      });
      this.update(gl, map);
      this.map = map;
    }

    update(gl, map){
        if(!this.options.visible){
            return
        }
        var center = map.getCenter();
        var zoom;
        var bounds = map.getBounds();
        var minTile,maxTile;
        if(this.options.tileType==='xyz'){
            zoom = parseInt(map.getZoom()+1.4);   //解决瓦片上文字偏大的问题
            //把当前显示范围做偏移，后面加载瓦片时会再偏移回来
            //如果不这样做的话，大比例尺时，瓦片偏移后，屏幕边缘会有空白区域
            var northWest = gps84_To_gcj02(bounds.getNorthWest())
            var southEast = gps84_To_gcj02(bounds.getSouthEast())
            //算出当前范围的瓦片编号
            minTile = lonLatToTileNumbers(northWest.lng, northWest.lat, zoom)
            maxTile = lonLatToTileNumbers(southEast.lng, southEast.lat, zoom)
        }else if(this.options.tileType==='bd09'){
            zoom = parseInt(map.getZoom()+1.8); //解决瓦片上文字偏大的问题
            var southWest = gps84_To_bd09(bounds.getSouthWest())
            var northEast = gps84_To_bd09(bounds.getNorthEast())
            minTile = this.transformBaidu.lnglatToTile(southWest.lng, southWest.lat, zoom)
            maxTile = this.transformBaidu.lnglatToTile(northEast.lng, northEast.lat, zoom)
        }
        var currentTiles = [];
        for(var x=minTile[0]; x<=maxTile[0]; x++){
            for(var y=minTile[1]; y<=maxTile[1]; y++){
                var xyz = {
                    x:x,
                    y:y,
                    z:zoom
                }
                // 不在层级范围内不创建瓦片
                if( zoom < this.options.minZoom || zoom > this.options.maxZoom){
                    continue
                }
                currentTiles.push(xyz)
                //把瓦片号对应的经纬度缓存起来，
                //存起来是因为贴纹理时需要瓦片4个角的经纬度，这样可以避免重复计算
                //行和列向外多计算一个瓦片数，这样保证瓦片4个角都有经纬度可以取到
                this.addGridCache(xyz, 0, 0)
                if(x === maxTile[0] ) this.addGridCache(xyz, 1, 0)
                if(y===maxTile[1]) this.addGridCache(xyz, 0, 1)
                if(x === maxTile[0] && y===maxTile[1]) this.addGridCache(xyz, 1, 1)
            }
        }

        //瓦片设置为从中间向周边的排序
        if(this.options.tileType === 'xyz') var centerTile = lonLatToTileNumbers(center.lng, center.lat, zoom)  //计算中心点所在的瓦片号
        else if(this.options.tileType === 'bd09') centerTile = this.transformBaidu.lnglatToTile(center.lng, center.lat, zoom)
        currentTiles.sort((a, b)=>{
			return this.tileDistance(a, centerTile) - this.tileDistance(b, centerTile);
		});

        //加载瓦片
        this.showTiles = [];
        for(var xyz of currentTiles){
            //走缓存或新加载
            if(this.tileCache[this.createTileKey(xyz)]){
                this.showTiles.push(this.tileCache[this.createTileKey(xyz)])
            }else{
                var tile = this.createTile(gl, xyz)
                this.showTiles.push(tile);
                this.tileCache[this.createTileKey(xyz)] = tile;
            }
        }
    }

    //缓存瓦片号对应的经纬度
    addGridCache(xyz, xPlus, yPlus){
        var key = this.createTileKey(xyz.x+xPlus, xyz.y+yPlus, xyz.z)
        if(!this.gridCache[key]){
            if(this.options.tileType === 'xyz') this.gridCache[key] = gcj02_To_gps84(tileNumbersToLonLat(xyz.x+xPlus, xyz.y+yPlus, xyz.z))
            else if(this.options.tileType === 'bd09') this.gridCache[key] = bd09_To_gps84(this.transformBaidu.pixelToLnglat(0, 0, xyz.x+xPlus, xyz.y+yPlus, xyz.z))
        }
    }

    //计算两个瓦片编号的距离
    tileDistance(tile1, tile2){
        //计算直角三角形斜边长度，c（斜边）=√（a²+b²）。（a，b为两直角边）
        return Math.sqrt(Math.pow((tile1.x - tile2[0]),2)+ Math.pow((tile1.y - tile2[1]),2))
    }

    //创建瓦片id
    createTileKey(xyz, y, z){
        if(xyz instanceof Object){
            return xyz.z+'/'+xyz.x+'/'+xyz.y;
        }else{
            var x = xyz;
            return z+'/'+x+'/'+y;
        }
    }

    //创建瓦片
    createTile(gl, xyz){
        //替换请求地址中的变量
        var _url = template(this.url, {
            s:this.options.subdomains[Math.abs(xyz.x + xyz.y) % this.options.subdomains.length],
            x:xyz.x,
            y:xyz.y,
            z:xyz.z
        });

        var tile = {
            xyz:xyz
        };

        //瓦片编号转经纬度，并进行偏移
        var leftTop,rightTop,leftBottom,rightBottom;
        if(this.options.tileType === 'xyz'){
            leftTop = this.gridCache[this.createTileKey(xyz)]
            rightTop = this.gridCache[this.createTileKey(xyz.x+1, xyz.y, xyz.z)] 
            leftBottom = this.gridCache[this.createTileKey(xyz.x, xyz.y+1, xyz.z)]  
            rightBottom = this.gridCache[this.createTileKey(xyz.x+1, xyz.y+1, xyz.z)]  
        }else if(this.options.tileType === 'bd09'){
            leftTop = this.gridCache[this.createTileKey(xyz.x, xyz.y+1, xyz.z)]
            rightTop = this.gridCache[this.createTileKey(xyz.x+1, xyz.y+1, xyz.z)] 
            leftBottom = this.gridCache[this.createTileKey(xyz)]  
            rightBottom = this.gridCache[this.createTileKey(xyz.x+1, xyz.y, xyz.z)] 
        }
        // 顶点坐标+纹理坐标
        var attrData = new Float32Array([
            leftTop.lng, leftTop.lat, 0.0, 1.0,
            leftBottom.lng, leftBottom.lat, 0.0, 0.0,
            rightTop.lng, rightTop.lat, 1.0, 1.0,
            rightBottom.lng, rightBottom.lat, 1.0, 0.0
        ])
        // var attrData = new Float32Array([
        //     116.38967958133532, 39.90811009556515, 0.0, 1.0,
        //     116.38967958133532, 39.90294980726742, 0.0, 0.0,
        //     116.39486013141436, 39.90811009556515, 1.0, 1.0,
        //     116.39486013141436, 39.90294980726742, 1.0, 0.0
        // ])

        var FSIZE = attrData.BYTES_PER_ELEMENT;
        //创建缓冲区并传入数据
        var buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, attrData, gl.STATIC_DRAW);
        tile.buffer = buffer;
        //从缓冲区中获取顶点数据的参数
        tile.PosParam = {
            size:2,
            stride:FSIZE * 4,
            offset:0
        }
        //从缓冲区中获取纹理数据的参数
        tile.TextCoordParam = {
            size:2,
            stride:FSIZE * 4,
            offset:FSIZE * 2
        }
        const leftTopLevel = this._convertMectorPoints(leftTop);
        const rightTopLevel = this._convertMectorPoints(rightTop);
        const leftBottomLevel = this._convertMectorPoints(leftBottom);
        const rightBottomLevel = this._convertMectorPoints(rightBottom);

        // 转为像素坐标处理
        const attrDataPixels = new Float32Array([
            Math.fround(leftTopLevel[0]),
            leftTopLevel[0] - Math.fround(leftTopLevel[0]),
            Math.fround(leftTopLevel[1]),
            leftTopLevel[1] - Math.fround(leftTopLevel[1]),
            0.0,
            1.0,
            Math.fround(leftBottomLevel[0]),
            leftBottomLevel[0] - Math.fround(leftBottomLevel[0]),
            Math.fround(leftBottomLevel[1]),
            leftBottomLevel[1] - Math.fround(leftBottomLevel[1]),
            0.0,
            0.0,
            Math.fround(rightTopLevel[0]),
            rightTopLevel[0] - Math.fround(rightTopLevel[0]),
            Math.fround(rightTopLevel[1]),
            rightTopLevel[1] - Math.fround(rightTopLevel[1]),
            1.0,
            1.0,
            Math.fround(rightBottomLevel[0]),
            rightBottomLevel[0] - Math.fround(rightBottomLevel[0]),
            Math.fround(rightBottomLevel[1]),
            rightBottomLevel[1] - Math.fround(rightBottomLevel[1]),
            1.0,
            0.0,
        ]);
        var FSIZE = attrDataPixels.BYTES_PER_ELEMENT;
        var bufferPixel = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, bufferPixel);
        gl.bufferData(gl.ARRAY_BUFFER, attrDataPixels, gl.STATIC_DRAW);
        tile.bufferPixel = bufferPixel;

        //从缓冲区中获取顶点数据的参数
        tile.PosPiexelsParam = {
            size: 4,
            stride: FSIZE * 6,
            offset: 0,
        };

        tile.TextPiexelsCoordParam = {
            size: 2,
            stride: FSIZE * 6,
            offset: FSIZE * 4,
        };

        //加载瓦片
        var img = new Image();
        img.onload = () => {
            // 创建纹理对象
            tile.texture = gl.createTexture();
            //向target绑定纹理对象
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            //对纹理进行Y轴反转
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, 1);
            //配置纹理图像
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);

            tile.isLoad = true;

            this.map.triggerRepaint()  //主动让地图重绘
        };
        img.crossOrigin = true;
        img.src = _url;

        return tile;
    }

    _convertMectorPoints(lnglat){
       const point = this.map.transform.locationCoordinate(
         lnglat
       );
       return [point.x, point.y, 0.0, 1.0];
    }
    
    //渲染
    render(gl, matrix) {
        if(this.map.getZoom() < this.options.minZoom || this.map.getZoom() > this.options.maxZoom || !this.options.visible) return
        //记录变换矩阵，用于瓦片加载后主动绘制
        this.matrix = matrix;

        //应用着色程序
        //必须写到这里，不能写到onAdd中，不然gl中的着色程序可能不是上面写的，会导致下面的变量获取不到
        gl.useProgram(this.program);
        for(var tile of this.showTiles){
            if(!tile.isLoad) continue;
            //向target绑定纹理对象
            gl.bindTexture(gl.TEXTURE_2D, tile.texture);
            //开启0号纹理单元
            gl.activeTexture(gl.TEXTURE0);
            //配置纹理参数
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
            // 获取纹理的存储位置
            var u_Sampler = gl.getUniformLocation(this.program, 'u_Sampler');
            //将0号纹理传递给着色器
            gl.uniform1i(u_Sampler, 0);

            gl.bindBuffer(gl.ARRAY_BUFFER, tile.bufferPixel);
            //激活顶点数据缓冲区（像素）
            gl.vertexAttribPointer(
                this.a_Pos_Piexl,
                tile.PosPiexelsParam.size,
                gl.FLOAT,
                false,
                tile.PosPiexelsParam.stride,
                tile.PosPiexelsParam.offset
            );
            gl.enableVertexAttribArray(this.a_Pos_Piexl);

            gl.vertexAttribPointer(
                this.a_TextCoord_Piexl,
                tile.TextPiexelsCoordParam.size,
                gl.FLOAT,
                false,
                tile.TextPiexelsCoordParam.stride,
                tile.TextPiexelsCoordParam.offset
            );
            gl.enableVertexAttribArray(this.a_TextCoord_Piexl);

            // 设置位置的顶点参数
            this.setVertex(gl, matrix)

            //开启阿尔法混合，实现注记半透明效果
            gl.enable(gl.BLEND);
            gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

            //绘制图形
            gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        }

    }

    // 设置位置的顶点参数
    //参考：https://github.com/xiaoiver/custom-mapbox-layer/blob/master/src/layers/PointCloudLayer2.ts
    setVertex(gl, matrix) {
        const currentZoomLevel = this.map.getZoom();
        const bearing = this.map.getBearing();
        const pitch = this.map.getPitch();
        const center = this.map.getCenter();

        // 因经纬度有精度问题，传入像素值作为顶点坐标处理
        const painter = this.map.painter
        const transform = this.map.transform
        const centerCoord = this._convertMectorPoints(center);
        
        const relativeToEyeMatrix = matrix.slice(); // copy the matrix;
        // translate the matrix by the center coord
        // as mat4.translate(matrix, matrix, [centerCoord[0], centerCoord[1], 0, 0])
        relativeToEyeMatrix[12] += relativeToEyeMatrix[0] * centerCoord[0] + relativeToEyeMatrix[4] * centerCoord[1];
        relativeToEyeMatrix[13] += relativeToEyeMatrix[1] * centerCoord[0] + relativeToEyeMatrix[5] * centerCoord[1];
        relativeToEyeMatrix[14] += relativeToEyeMatrix[2] * centerCoord[0] + relativeToEyeMatrix[6] * centerCoord[1];
        relativeToEyeMatrix[15] += relativeToEyeMatrix[3] * centerCoord[0] + relativeToEyeMatrix[7] * centerCoord[1];

        let drawParams = {
          u_custom_matrix: relativeToEyeMatrix,
          u_center_pos: new Float32Array([
            Math.fround(centerCoord[0]),
            centerCoord[0] - Math.fround(centerCoord[0]),
            Math.fround(centerCoord[1]),
            centerCoord[1] - Math.fround(centerCoord[1])
          ]),
          u_opacity:this.options.opacity,
        };
        gl.uniformMatrix4fv(gl.getUniformLocation(this.program, "u_custom_matrix"),false, drawParams['u_custom_matrix']);
        gl.uniform4fv(gl.getUniformLocation(this.program, "u_center_pos"), drawParams['u_center_pos']);
        gl.uniform1f(
            gl.getUniformLocation(this.program, "u_opacity"),
            drawParams["u_opacity"]
        );
    }

    /**
     * @description 设置透明度
     * @param {*} opacity
     * @return {*}
     */
    setOpacity(opacity){
        this.options.opacity = opacity
        this._requestRender();
    }

    /**
     * @description 设置显示和隐藏
     * @param {*} visible
     * @return {*}
     */
    setVisible(visible){
      // 显示时重新计算瓦片
      if (visible && !this.options.visible && this.map) {
        this.options.visible = visible;
        this.update(this.map.painter.context.gl, this.map);
      } else {
        this.options.visible = visible;
      }
      this._requestRender();
    }

    _requestRender(){
        var map = this.map
        if (!map) return;
        map._update()
    }

    //当map移除当前图层时调用
    onRemove(map, gl){
        this.isLayerShow = false;
    }
}